import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyLayoutBrannanSinglePage = loadable(
  () => import(/* webpackChunkName: "content/guest/layouts/brannan-single-page" */ './LayoutBrannanSinglePage'),
  'LayoutBrannanSinglePage',
);
